import { breakpoints } from '@/utils/breakpoints';
import { Divider, Skeleton } from '@packages/webshop-design-system';
import { useMediaQuery } from 'react-responsive';

const StopDetailsSkeleton = () => (
  <div className="flex flex-col gap-4">
    <div className="flex gap-3">
      <div className="relative flex flex-col items-center px-1 pb-1.5 pt-1.5">
        <Skeleton className="relative z-10 h-5 w-5 rounded-full" />
        <div className="absolute bottom-4 left-1/2 top-6 w-0.5 -translate-x-1/2 bg-neutral-light" />
        <Skeleton className="relative z-10 mt-auto h-5 w-5 rounded-full" />
      </div>
      <div className="flex w-full flex-col justify-between gap-6 py-0.5">
        <div className="flex items-center justify-between">
          <Skeleton className="h-5 w-36" />
          <Skeleton className="h-5 w-12" />
        </div>
        <div className="flex items-center justify-between">
          <Skeleton className="h-5 w-40" />
          <Skeleton className="h-5 w-12" />
        </div>
      </div>
    </div>
    <div className="flex">
      <Skeleton className="h-7 w-20 rounded-l rounded-r-none" />
      <Skeleton className="h-7 w-24 rounded-l-none rounded-r" />
    </div>
  </div>
);

const OfferCardSkeleton = () => (
  <div className="flex w-full flex-col overflow-hidden rounded-lg border border-neutral-pale">
    <div className="flex flex-grow flex-col gap-1 border-b border-neutral-pale px-4 py-3">
      <div className="flex flex-row items-center justify-between gap-2">
        <Skeleton className="h-5 w-28" />
        <Skeleton className="h-5 w-16" />
      </div>
      <Divider className="my-3" />
      <Skeleton className="mb-1 h-4 w-full" />
      <Skeleton className="h-4 w-4/5" />
      <div className="mt-2 flex flex-row gap-1">
        <Skeleton className="h-5 w-20" />
        <Skeleton className="h-5 w-24" />
      </div>
    </div>
    <Skeleton className="h-10 w-full rounded-none" />
  </div>
);

const JourneyOfferListSkeleton = () => {
  const isLaptopOrBigger = useMediaQuery({ minWidth: breakpoints.laptop });

  return (
    <div className="flex flex-col gap-6 p-4 laptop:flex-row laptop:items-start">
      <div className="flex flex-col gap-4 laptop:w-[328px]">
        <div className="laptop:flex-shrink-0">
          <StopDetailsSkeleton />
        </div>
      </div>
      {isLaptopOrBigger ? (
        <div className="flex flex-1 flex-row gap-3">
          <div className="flex w-full flex-col gap-3">
            <OfferCardSkeleton />
            <OfferCardSkeleton />
          </div>
          <div className="flex w-full flex-col gap-3">
            <OfferCardSkeleton />
          </div>
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          <OfferCardSkeleton />
          <OfferCardSkeleton />
          <OfferCardSkeleton />
        </div>
      )}
    </div>
  );
};

export default JourneyOfferListSkeleton;
